export default __webpack_public_path__ + "static/walkways-e55b83647f5d4ba6aa6bfdf392aa83ef.webp";